"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EContractStatus = exports.EContractType = void 0;
var EContractType;
(function (EContractType) {
    EContractType[EContractType["PERPETUAL"] = 0] = "PERPETUAL";
    EContractType[EContractType["CURRENT_MONTH"] = 1] = "CURRENT_MONTH";
    EContractType[EContractType["NEXT_MONTH"] = 2] = "NEXT_MONTH";
    EContractType[EContractType["CURRENT_QUARTER"] = 3] = "CURRENT_QUARTER";
    EContractType[EContractType["NEXT_QUARTER"] = 4] = "NEXT_QUARTER";
    EContractType[EContractType["PERPETUAL_DELIVERING"] = 5] = "PERPETUAL_DELIVERING";
})(EContractType = exports.EContractType || (exports.EContractType = {}));
var EContractStatus;
(function (EContractStatus) {
    EContractStatus[EContractStatus["PENDING_TRADING"] = 0] = "PENDING_TRADING";
    EContractStatus[EContractStatus["TRADING"] = 1] = "TRADING";
    EContractStatus[EContractStatus["PRE_DELIVERING"] = 2] = "PRE_DELIVERING";
    EContractStatus[EContractStatus["DELIVERING"] = 3] = "DELIVERING";
    EContractStatus[EContractStatus["DELIVERED"] = 4] = "DELIVERED";
    EContractStatus[EContractStatus["PRE_SETTLE"] = 5] = "PRE_SETTLE";
    EContractStatus[EContractStatus["SETTLING"] = 6] = "SETTLING";
    EContractStatus[EContractStatus["CLOSE"] = 7] = "CLOSE";
})(EContractStatus = exports.EContractStatus || (exports.EContractStatus = {}));
